import angular from 'angular';

import ManageIconsComponent from './manage-icons-component';
import { ManageIconsController } from './manage-icons-controller';

export default angular
  .module('manage-icons', [])
  .controller('ManageIconsController', ManageIconsController)
  .component('manageIcons', ManageIconsComponent);



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/manage-icons/manage-icons-module.js